import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EndpointService } from './endpoint.service';
import { RolePermission } from '../models/rolePermission.model';

@Injectable({
  providedIn: 'root',
})
export class RolePermissionService extends EndpointService {
  constructor(http: HttpClient) {
    super(http);
  }

  getMyRolePermissions(): Observable<RolePermission[]> {
    return this.http.get<RolePermission[]>(this.getApiUrl('RolePermission/GetMy'));
  }
}
